import moment = require('moment');
import * as React from 'react';
import {FunctionComponent, useState} from 'react';
// @ts-ignore
import {DateRangePicker} from 'react-dates-gte-react-17';
import {DateRange} from '../../../Domain/DateRange';
import {isSameDay} from 'date-fns';
import {classNames} from '../../Support/classNames';
import {useWindowSize} from '../../Support/useWindowSize';

interface OwnProps {
    range: DateRange | null | undefined;
    onChange: (range: DateRange) => void;

    className?: string;
}

export const WorkoutDateRangePicker: FunctionComponent<OwnProps> = ({range, onChange, className}) => {
    const windowSize = useWindowSize();
    const [focusedInput, setFocusedInput] = useState<any>(null);

    const presets = [
        {
            text: 'Last year',
            start: moment().subtract(1, 'year').startOf('year'),
            end: moment().subtract(1, 'year').endOf('year'),
        },
        {
            text: 'This year',
            start: moment().startOf('year'),
            end: moment().endOf('year'),
        },
        {
            text: 'Last quarter',
            start: moment().subtract(1, 'quarter').startOf('quarter'),
            end: moment().subtract(1, 'quarter').endOf('quarter'),
        },
        {
            text: 'This quarter',
            start: moment().startOf('quarter'),
            end: moment().endOf('quarter'),
        },
        {
            text: 'Last month',
            start: moment().subtract(1, 'month').startOf('month'),
            end: moment().subtract(1, 'month').endOf('month'),
        },
        {
            text: 'This month',
            start: moment().startOf('month'),
            end: moment().endOf('month'),
        },
    ];

    let startDate: any = null;
    if (range && range.from) {
        startDate = moment(range.from);
    }

    let endDate: any = null;
    if (range && range.till) {
        endDate = moment(range.till);
    }

    const renderDatePresets = () => {
        return (
            <div className="workoutsdaterangepicker__presets">
                {presets.map((preset: {text: string; start: any; end: any}) => {
                    const isSelected =
                        startDate !== null &&
                        isSameDay(preset.start.toDate(), startDate.toDate()) &&
                        endDate !== null &&
                        isSameDay(preset.end.toDate(), endDate.toDate());

                    return (
                        <button
                            key={preset.text}
                            type="button"
                            className={classNames('btn btn-sm workoutsdaterangepicker__preset', {
                                'workoutsdaterangepicker__preset--selected': isSelected,
                                'btn-primary': isSelected,
                            })}
                            onClick={() =>
                                onChange({
                                    from: preset.start.toDate(),
                                    till: preset.end.toDate(),
                                })
                            }
                        >
                            {preset.text}
                        </button>
                    );
                })}
            </div>
        );
    };

    return (
        <div className={classNames('workoutsdaterangepicker', className)}>
            <DateRangePicker
                block={true}
                displayFormat="DD-MM-YYYY"
                renderCalendarInfo={renderDatePresets}
                hideKeyboardShortcutsPanel
                isOutsideRange={() => false}
                transitionDuration={0}
                startDate={startDate}
                startDateId="startDate"
                startDatePlaceholderText="From"
                endDatePlaceholderText="Till"
                customArrowIcon={<i className="bi bi-arrow-right-short" />}
                customInputIcon={<i className="bi bi-calendar-check" />}
                inputIconPosition="after"
                endDate={endDate}
                endDateId="endDate"
                withFullScreenPortal={windowSize.width < 768}
                numberOfMonths={windowSize.width > 768 ? 2 : 1}
                orientation={windowSize.width > 768 ? 'horizontal' : 'vertical'}
                onDatesChange={(updatedRange: any) => {
                    onChange({
                        from: updatedRange.startDate ? updatedRange.startDate.toDate() : null,
                        till: updatedRange.endDate ? updatedRange.endDate.toDate() : null,
                    });
                }}
                focusedInput={focusedInput}
                onFocusChange={(updatedFocusedInput: any) => setFocusedInput(updatedFocusedInput)}
            />
        </div>
    );
};
